<!--
  ~ Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->


<div class="head">
    {{ title }}
</div>
<div class="content">
    <form #form='ngForm' autocomplete="off">
        <tabset>
            <tab heading="Dienst">
                <div class="form-row">
                    <div class="w-col-12">
                        <div class="form-group">
                            <label [for]="id('project')">Project</label>
                            @if (!isExternItem) {
                                <ng-select [id]="id('project')" [(ngModel)]="record.project_id" class="form-control"
                                           [appendTo]="dropdownContainer"
                                           name="project"
                                           [disabled]="readonly || isExterneBewerker"
                                           (change)="projectChange()">
                                    @for (project of projects; track project.id) {
                                        <ng-option [value]="project.id">{{ project.label }}
                                        </ng-option>
                                    }
                                </ng-select>
                            } @else {
                                <div class="form-control-plaintext border p-2 rounded bg-light">
                                    <strong>{{ getExternWerkmaatschappijNaam() }}:</strong> {{ getExternProjectLabel() }}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="w-col-4">
                        <div class="form-group">
                            <label [for]="id('startdate')">Datum</label>
                            <sihwdatepicker class="form-control" [id]="id('startdate')" required name="startdate"
                                            placeholder="dd-mm-jjjj"
                                            [(ngModel)]="record.startdate" [bsConfig]="datepickerconfig"
                                            [minDate]="mindate" [maxDate]="record.project?.einddatum"
                                            (ngModelChange)="momentChange()"
                                            [disabled]="readonly || isExterneBewerker"></sihwdatepicker>
                        </div>
                    </div>
                    <div class="w-col-4">
                        <div class="form-group">
                            <label [for]="id('starttime')">Begin</label>
                            <sihwtijdveld class="form-control" [id]="id('starttime')" required name="starttime"
                                          placeholder="uu:mm"
                                          [(ngModel)]="record.starttime" [voorloopnul]="true"
                                          (ngModelChange)="momentChange()"
                                          [disabled]="readonly || isExterneBewerker"></sihwtijdveld>
                        </div>
                    </div>
                    <div class="w-col-4">
                        <div class="form-group">
                            <label [for]="id('endtime')">Eind</label>
                            <sihwtijdveld class="form-control" [id]="id('endtime')" required name="endtime"
                                          placeholder="uu:mm"
                                          [(ngModel)]="record.endtime" [voorloopnul]="true"
                                          (ngModelChange)="momentChange()"
                                          [disabled]="readonly || isExterneBewerker"></sihwtijdveld>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="w-col-3 w-col-md-2">
                        <div class="form-group">
                            <label [for]="id('capacity')">Capaciteit</label>
                            <input class="form-control" type="number" min="1" step="1" [id]="id('capacity')"
                                   name="capacity"
                                   [disabled]="readonly || isExterneBewerker"
                                   [(ngModel)]="record.capacity" required (change)="fixPersoneelrows()"
                                   (ngModelChange)="roundCapacity()">
                        </div>
                    </div>
                    <div class="w-col-9 w-col-md-6">
                        <div class="form-group">
                            <label [for]="id('mainfunction')">Functie</label>
                            <ng-select class="form-control" [id]="id('mainfunction')" bindValue="id" name="mainfunction"
                                       [appendTo]="dropdownContainer"
                                       [disabled]="readonly || isExterneBewerker"
                                       [(ngModel)]="record.mainFunction" (change)="functionsChanged()">
                                @for (func of visibleRelevantFunctions; track func.id) {
                                    <ng-option [value]="func.id">{{ func.naam }}</ng-option>
                                }
                            </ng-select>
                        </div>
                    </div>
                    <div class="w-col-6 w-col-md-4">
                        <div class="form-group">
                            <label [for]="id('aanvraagnummer')">Aanvraagnummer <span class="inforondje"
                                                                                     title="Extern aanvraagnummer"></span></label>
                            <input class="form-control" type="text" maxlength="20" [id]="id('aanvraagnummer')"
                                   name="aanvraagnummer"
                                   [(ngModel)]="record.aanvraagnummer" [disabled]="readonly || isExterneBewerker">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label [for]="id('functionalias')">Rijalias <span class="inforondje"
                                                                      title="Maak een aparte rij op het planbord met deze extra omschrijving"></span></label>
                    <input class="form-control" type="text" maxlength="100" [id]="id('functionalias')"
                           name="functionalias"
                           [(ngModel)]="record.functionalias" [disabled]="readonly || isExterneBewerker">
                </div>
                @if (magExtern && !isExternItem) {
                    <div class="form-row">
                        <div class="w-col-12 w-col-md-6">
                            @if (!record.externe_werkmaatschappij) {
                                <div class="form-group">
                                    <label [for]="id('leverancier')">In te vullen door leverancier:</label>
                                    <ng-select [id]="id('leverancier')" name="leverancier" class="form-control"
                                               [appendTo]="dropdownContainer"
                                               [disabled]="readonly"
                                               [(ngModel)]="record.leverancier_id" bindValue="id">
                                        @for (leverancier of leveranciersInWM(); track leverancier.id) {
                                            <ng-option [value]="leverancier.id">{{ leverancier.naam }}
                                            </ng-option>
                                        }
                                    </ng-select>
                                </div>
                            }
                            @if (!record.leverancier_id) {
                                <div class="form-group">
                                    <label [for]="id('externe_wm')">In te vullen door externe werkmaatschappij:</label>
                                    <ng-select [id]="id('externe_wm')" name="externe_werkmaatschappij" class="form-control"
                                               [appendTo]="dropdownContainer"
                                               [(ngModel)]="record.externe_werkmaatschappij" [disabled]="!kanExterneWmWijzigen"
                                               bindValue="id" [clearable]="true">
                                        @for (wm of externeWerkmaatschappijen; track wm.id) {
                                            <ng-option [value]="wm.id">
                                                {{ wm.naam }}
                                            </ng-option>
                                        }
                                    </ng-select>
                                </div>
                            }
                        </div>
                        @if (record.leverancier_id) {
                            <div class="w-col-12 w-col-md-6">
                                <div class="form-group">
                                    <label [for]="id('leverancierlock')">Invullingsslot</label>
                                    <select class="form-control" [id]="id('leverancierlock')" name="leverancierlock"
                                            [(ngModel)]="record.leverancierlock" required [disabled]="readonly">
                                        <option value="auto">Sluit automatisch</option>
                                        <option value="dicht">Altijd afgesloten</option>
                                        <option value="open">Altijd geopend</option>
                                    </select>
                                    <small>Alleen bij een open invullingsslot kan de leverancier de invulling wijzigen.
                                        @if (record.leverancierlock === 'auto') {
                                            @if (record.gelockt) {
                                                Dit slot is automatisch gesloten
                                                op {{ record.leverancierSluitmoment }}.
                                            }
                                            @if (! record.gelockt) {
                                                Dit slot sluit automatisch op {{ record.leverancierSluitmoment }}.
                                            }
                                        }
                                    </small>
                                </div>
                            </div>
                        }
                    </div>
                }
                <div class="form-group">
                    <label [for]="id('opmerkingen')">Opmerkingen voor uitvoerders</label>
                    <textarea class="form-control" [id]="id('opmerkingen')" [disabled]="readonly || isExterneBewerker"
                              name="opmerkingen"
                              [(ngModel)]="record.opmerkingen"></textarea>
                </div>

                @if (lookups.functions) {
                    <div class="d-flex justify-content-between align-items-center">
                        <label class="mb-0">Extra functies</label>
                    </div>
                    @for (func of visibleRelevantFunctions; track func.id) {
                        @if (func.id !== record.mainFunction) {
                            <div class="select-pill" [class.select]="record.hasExtrafunction(func)"
                                 (click)="toggleExtrafunction(func)">{{ func.naam }}
                            </div>
                        }
                    }
                }
                @if ((! readonly) && (! isExterneBewerker) && (! record.serieskey)) {
                    <div class="form-row mt-3 mb-2">
                        <div class="w-col-12">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" [id]="id('planSeries')"
                                       name="planSeries"
                                       [(ngModel)]="planSeries.create">
                                <label class="form-check-label" [for]="id('planSeries')">
                                    Maak een serie
                                </label>
                            </div>
                        </div>
                    </div>
                    @if (planSeries.create) {
                        <div class="form-row">
                            <div class="w-col-4 w-col-sm-3 w-col-lg-2">
                                <div class="form-group">
                                    <label [for]="id('planseries_enddatum')">T/M einddatum</label>
                                    <sihwdatepicker class="form-control" [id]="id('planseries_enddatum')" required
                                                    name="planseries_enddatum"
                                                    placeholder="dd-mm-jjjj"
                                                    [(ngModel)]="planSeries.endDate" [bsConfig]="datepickerconfig"
                                                    [minDate]="record.startdate"
                                                    [maxDate]="record.project?.einddatum"></sihwdatepicker>
                                </div>
                            </div>
                            <div class="w-col-8 w-col-md-6 w-col-lg-5">
                                <div class="div">
                                    <label>Weekdagen (start)</label>
                                </div>
                                <div class="mt-1">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_mon')"
                                               [(ngModel)]="planSeries.weekdays.mon" name="weekdays_mon">
                                        <label class="form-check-label" [for]="id('weekdays_mon')">Ma</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_tue')"
                                               [(ngModel)]="planSeries.weekdays.tue" name="weekdays_tue">
                                        <label class="form-check-label" [for]="id('weekdays_tue')">Di</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_wed')"
                                               [(ngModel)]="planSeries.weekdays.wed" name="weekdays_wed">
                                        <label class="form-check-label" [for]="id('weekdays_wed')">Wo</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_thu')"
                                               [(ngModel)]="planSeries.weekdays.thu" name="weekdays_thu">
                                        <label class="form-check-label" [for]="id('weekdays_thu')">Do</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_fri')"
                                               [(ngModel)]="planSeries.weekdays.fri" name="weekdays_fri">
                                        <label class="form-check-label" [for]="id('weekdays_fri')">Vrij</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_sat')"
                                               [(ngModel)]="planSeries.weekdays.sat" name="weekdays_sat">
                                        <label class="form-check-label" [for]="id('weekdays_sat')">Za</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" [id]="id('weekdays_sun')"
                                               [(ngModel)]="planSeries.weekdays.sun" name="weekdays_sun">
                                        <label class="form-check-label" [for]="id('weekdays_sun')">Zo</label>
                                    </div>
                                </div>
                            </div>
                            <div class="w-col-4 w-col-sm-3 w-col-md-2">
                                <div class="form-group">
                                    <label [for]="id('everyNumWeeks')">Om de X week</label>
                                    <input type="number" class="form-control" min="1" max="52" step="1" required
                                           name="everyNumWeeks"
                                           [id]="id('everyNumWeeks')"
                                           [(ngModel)]="planSeries.everyNumWeeks" (ngModelChange)="roundNumWeeks()">
                                </div>
                            </div>
                        </div>
                        <p class="small">{{ planSeriesText() }}</p>
                    }
                }
                @if ((! readonly) && (! isExterneBewerker) && record?.seriesItems?.length) {
                    <hr>
                    <h4>Serie</h4>
                    <p>Deze dienst maakt deel uit van een serie van {{ record.seriesItems.length }} diensten
                        tussen {{ seriesdate('first') }}
                        en {{ seriesdate('last') }}. De items zijn los van elkaar te bewerken. Je kan wel de invulling
                        van de hele serie (vanaf deze) wijzigen in de tab invulling. Je kan ook de hele serie
                        in één keer
                        verwijderen. Deze dienst blijft dan over. Ook kan je juist deze dienst losmaken van de rest van
                        de
                        serie.</p>
                    <div class="d-flex justify-content-between">
                        <button class="btn btn-primary" [disabled]="readonly" (click)="detachFromSeries()"
                                title="Koppel deze dienst los van de serie, zodat hij niet verwijderd wordt als je de serie verwijdert. Na het opslaan is de dienst losgekoppeld.">
                            Loskoppelen
                        </button>
                        <button class="btn btn-danger" [disabled]="readonly || (! canDeleteSeries())"
                                (click)="deleteSeries()"
                                title="Verwijder alle andere diensten uit de serie. Deze dienst blijft.">Verwijder
                            overige
                        </button>
                    </div>
                }
            </tab>
            <tab heading="Invulling">
                @if ((magPersoneelEdit) && (!isExterneBewerker) && extraRecords?.length) {
                    <div class="custom-control custom-switch mb-2">
                        <input type="checkbox" class="custom-control-input" [id]="id('saveExtra')"
                               name="saveExtra"
                               [(ngModel)]="saveExtra" [ngModelOptions]="{standalone: true}">
                        <label class="custom-control-label" [for]="id('saveExtra')"
                               title="Pas de invulling toe op deze dienst en alle volgende diensten in de geselecteerde reeks">Ook
                            volgende diensten</label>
                    </div>
                    @if (saveExtra) {
                        <div class="text-danger mb-2">Let op: hiermee vervang je de invulling van deze dienst en alle
                            <em>volgende</em> diensten in de reeks. We controleren hier niet op overlap / vrije dagen.
                            Controleer dus zelf goed de volgende diensten.
                        </div>
                    }
                }
                <planitem-invulling
                        [record]="record"
                        [readonly]="readonly"
                        [isLeverancier]="isLeverancier"
                        [isUitlener]="isUitlener"
                        [volLezen]="volLezen"
                        [magPersoneelEdit]="magPersoneelEdit"
                        [lookups]="lookups"
                        [lookupHashes]="lookupHashes"
                        [negeerFilter]="negeerFilter"
                        [allitemsPerdate]="allitemsPerdate"
                        [dropdownContainer]="dropdownContainer"
                        [filtertool]="filtertool">
                </planitem-invulling>
            </tab>
            @if (magLog) {
                <!--        ACL van planitemlog gaat via planitem -->
                <tab heading="Log" (selectTab)="initLogtab()">
                    @for (log of record.planitemlog; track log.id) {
                        <div class="logregel">
                            <div class="logheader">
                                <div class="logactie">{{ log.actie }}</div>
                                <div class="logdatum">{{ log.createdAt | mdate:"D-M-YYYY HH:mm" }}</div>
                                <div class="loggebruiker">{{ log.gebruiker?.naam || log.gebruiker?.gebruikersnaam || '?' }}</div>
                            </div>
                            <div class="logdetail">{{ log.wijzigingen_tekst }}</div>
                        </div>
                    }
                </tab>
            }
        </tabset>
    </form>
</div>
<div class="foot">
    <div class="buttons" links>
        <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
        @if (!readonly && !isNieuw && !isExterneBewerker) {
            <button class="btn btn-danger" (click)="delete()" [disabled]="!canDelete"
                    [attr.title]="canDelete? 'Verwijder dit item' : 'Dit item kan niet verwijderd worden, omdat ernaar wordt verwezen.'">
                Verwijderen
            </button>
        }
    </div>
    <div class="buttons" rechts>
        @if (ietsWeggefilterd) {
            <div class="mr-2">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [id]="id('negeerFilter')"
                           name="negeerFilter"
                           [(ngModel)]="negeerFilter" [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="negeerFilterChanged()">
                    <label class="custom-control-label text-light" [for]="id('negeerFilter')"
                           title="Schakel toepassen van planbordfilter voor keuzes in dit scherm aan of uit">Negeer
                        planbordfilter</label>
                </div>
            </div>
        }
        @if (!readonly && !shouldReload) {
            <button class="btn btn-primary" (click)="save()"
                    [disabled]="((!isDirty) && (!record.isNieuw())) || (!canSave())">
                Opslaan
            </button>
            @if (!isExterneBewerker) {
                <button class="btn btn-primary" (click)="save(true)"
                        title="Sla het planitem op en meld de betrokken personeelsleden van de wijziging"
                        [disabled]="((!isDirty) && (!record.isNieuw())) || (!canSave())">
                    Opslaan + melding
                </button>
            }
        }
        @if (shouldReload) {
            <button class="btn btn-warning" (click)="reload()">Herladen (gewijzigd)</button>
        }
    </div>
</div>

